<template>
  <div class="wrapper">
    <notifications></notifications>
    <side-bar>
      <template slot="links">
        <sidebar-item
          true
          :link="{
            name: 'Tableau de bord',
            icon: 'ni ni-shop text-primary',
            path: '/dashboard',
          }"
        >
        </sidebar-item>

        <sidebar-item
          :opened="$route.path.startsWith('/events')"
          v-if="roles.includes('administrator')"
          :link="{
            name: 'Evenements',
            path: '/events',
            icon: 'ni ni-calendar-grid-58 text-info',
          }"
        >
        </sidebar-item>

        <sidebar-item
          :opened="$route.path.startsWith('/invoices')"
          v-if="roles.includes('administrator')"
          :link="{
            name: 'Factures',
            path: '/invoices',
            icon: 'ni ni-single-copy-04 text-primary',
          }"
        >
        </sidebar-item>

        <sidebar-item
          :opened="$route.path.startsWith('/payments')"
          v-if="roles.includes('administrator')"
          :link="{
            name: 'Paiements',
            path: '/payments',
            icon: 'ni ni-money-coins text-primary',
          }"
        >
        </sidebar-item>

        <sidebar-item
          :opened="$route.path.startsWith('/registrations')"
          v-if="roles.includes('administrator')"
          :link="{
            name: 'Inscriptions',
            path: '/registrations',
            icon: 'ni ni-single-02 text-primary',
          }"
        >
        </sidebar-item>

        <sidebar-item
          :opened="$route.path.startsWith('/admin')"
          v-if="roles.includes('administrator')"
          :link="{
            name: 'Administration',
            icon: 'ni ni-settings text-success',
          }"
        >
          <sidebar-item
            :link="{
              name: 'Roles',
              path: '/admin/roles',
            }"
          />
          <sidebar-item
            :link="{
              name: 'Utilisateurs',
              path: '/admin/users',
            }"
          />
        </sidebar-item>
      </template>
    </side-bar>
    <div class="main-content">
      <dashboard-navbar :type="$route.meta.navbarType"></dashboard-navbar>

      <div @click="$sidebar.displaySidebar(false)">
        <fade-transition :duration="200" origin="center top" mode="out-in">
          <!-- your content here -->
          <router-view></router-view>
        </fade-transition>
      </div>
      <content-footer v-if="!$route.meta.hideFooter"></content-footer>
    </div>
  </div>
</template>
<script>
/* eslint-disable no-new */
import PerfectScrollbar from "perfect-scrollbar";
import "perfect-scrollbar/css/perfect-scrollbar.css";

function hasElement(className) {
  return document.getElementsByClassName(className).length > 0;
}

function initScrollbar(className) {
  if (hasElement(className)) {
    new PerfectScrollbar(`.${className}`);
  } else {
    // try to init it later in case this component is loaded async
    setTimeout(() => {
      initScrollbar(className);
    }, 100);
  }
}

import DashboardNavbar from "./DashboardNavbar.vue";
import ContentFooter from "./ContentFooter.vue";
import { FadeTransition } from "vue2-transitions";
import Vuex from "vuex";

export default {
  components: {
    DashboardNavbar,
    ContentFooter,
    FadeTransition,
  },
  data() {
    return {
      roles: [],
    };
  },
  methods: {
    initScrollbar() {
      let isWindows = navigator.platform.startsWith("Win");
      if (isWindows) {
        initScrollbar("sidenav");
      }
    },
  },
  async mounted() {
    this.initScrollbar();
    try {
      await this.$store.dispatch("profile/me");
    } catch (e) {
      if (e.response) {
        if ([401, 403].includes(e.response.status)) {
          this.$store.dispatch("logout");
        }
      } else {
        throw e;
      }
    }
  },
  computed: {
    ...Vuex.mapState({
      me: (state) => state.profile.me,
    }),
  },
  watch: {
    me: {
      handler: function (val) {
        this.roles = val.roles.map((r) => r.name);
      },
      deep: true,
    },
  },
};
</script>
<style lang="scss">
body.g-sidenav-hidden {
  #purchase-button,
  #demo-button,
  #star-button,
  #docs-button {
    margin-left: 8px;
    margin-right: 8px;
    padding: 11px 0px;
  }
}
body.g-sidenav-show {
  #purchase-button,
  #demo-button,
  #star-button,
  #docs-button {
    margin-left: 20px;
    margin-right: 20px;
    padding: 11px 0px;
  }
}
</style>
